import moment, { Moment } from 'moment';
import 'moment/locale/pt-br';

export const DATE_FORMATS = {
  DD_MMM: 'DD MMM',
  YYYY: 'YYYY',
};

const PREPOSITIONS = ['da', 'de', 'di', 'do', 'du', 'ao', 'das', 'dos'];

// TEXT FORMATTING
export const capitalizeFirstLetter = (text: string, onlyFirst = false) => {
  try {
    if (onlyFirst) {
      return text.charAt(0).toUpperCase().concat(text.slice(1));
    }

    if (text.length > 1) {
      const words = text.trim().split(' ');
      return words
        .map(([first, ...rest]) => {
          const word = String(first + rest);

          const isPreposition = PREPOSITIONS.includes(word.toLowerCase());

          if (isPreposition) {
            return String(word).toLowerCase();
          }
          if (!first || !rest) {
            return '';
          }
          return first?.toUpperCase() + rest?.join('').toLowerCase();
        })
        .join(' ');
    }

    return text;
  } catch (error) {
    return text;
  }
};

export const formatStringsToPlural = (label: string, index: number) => {
  return `${index} ${label
    .split(' ')
    .map((word) => {
      if (index !== 1) {
        if (word.includes('ível')) {
          return word.replace('ível', 'íveis');
        }

        if (word.includes('ção')) {
          return word.replace('ção', 'ções');
        }

        if (word.endsWith('r')) {
          return word.concat('es');
        }

        return word.concat('s');
      }

      return word;
    })
    .join(' ')}`;
};

// DATES FORMATTING
export const formatDate = (date: Moment | string | null, format: string) => {
  return moment(date).locale('pt-br').format(format);
};

export const formatDateCreatedAt = (createdAt: string) => {
  const momentCreatedAt = moment(createdAt);

  if (momentCreatedAt.isBefore()) {
    return `em ${momentCreatedAt.format('DD/MM/YYYY [às] HH[h]mm')}`;
  }

  return `hoje às ${momentCreatedAt.format('HH[h]mm')}`;
};

// NUMBER FORMATTING
export const addLeadingZero = (number: number) => {
  let numberString = String(number);

  if (numberString.length < 2) {
    numberString = '0' + numberString;
  }

  return numberString;
};
